// extracted by mini-css-extract-plugin
export default {"formInputs":"FormInputs_formInputs__YYHjn"};